import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, FormElement, Field } from "@progress/kendo-react-form";
import { Label } from "@progress/kendo-react-labels";
import { Input } from "@progress/kendo-react-inputs";
import { Grid, useMediaQuery } from "@material-ui/core";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { InputsFormPure, DialogSystemGLPure } from "../../pures";
import PhoneInput from 'react-phone-number-input'

/* === Custom component title for dialog === */
const CustomTitleBar = () => {
  const { t } = useTranslation();
  const matches = useMediaQuery("(min-width:740px)");
  let customTitleBarStyles = {
    color: "#FFFFFF",
    fontSize: "17px",
    textAlign: "left",
    paddingTop: "5px",
    fontFamily: "Quicksand, sans-serif",
  };
  if (matches) {
    customTitleBarStyles.margin = 0;
  }
  return (
    <div style={customTitleBarStyles}>
      <span>{t("dialogUpdateUserAddress.titleEditUserAddres")}</span>
    </div>
  );
};

const dialogUserData = {
  // marginBottom: '15px',
  // paddingRight: '20px',
  // lineHeight: '1'
  maxWidth: "100%",
  display: "flex",
  fontSize: "13px",
  paddingTop: "15px",
  margin: "auto",
  alignItems: "center"
};

const LeftGrid = {
  paddingRight: "24px",
};

const DialogUpdateUserAddress = (props) => {
  const { t } = useTranslation();
  // let phoneNumber = props.phoneNumber;
  // let cellphoneNumber = props.cellphoneNumber;
  // if (phoneNumber === "0") phoneNumber = "";
  // if (cellphoneNumber === "0") cellphoneNumber = "";

  return (
    <div>
      {/* <Tooltip
        openDelay={600}
        position="top"
        anchorElement="target"
        tooltipClassName="tooltipGeneralStyle"
      > */}
      <button
        title={t("dialogUpdateUserAddress.tooltipButtonDialogEdit")}
        className="dialogUpdateAdrresss-buttton-edit"
        onClick={props.toggleDialogUpdateUserAddress}
      >
        {t("dialogUpdateUserAddress.buttonEdit")}
      </button>
      {/* </Tooltip> */}
      {props.visibleDialogUpdate && !props.showLoadingRequesting && (
        <Dialog
          title={<CustomTitleBar />}
          height={550}
          onClose={props.toggleDialogUpdateUserAddress}
        >
          {/* Form container */}
          <Form
            onSubmit={props.onSubmitUpdateUserAddress}
            valid={true}
            render={() => (
              <FormElement
                style={{
                  maxWidth: "900px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {/* <fieldset className={'k-form-fieldset fieldset'}> */}
                {/* User information */}
                <Grid
                  container
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  spacing={1}
                  style={{ textAlign: "left", justifyContent: "center" }}
                >
                  <Grid xs={12} lg={6} md={6} sm={12} es={6} spacing={12}>
                    <Grid
                      item
                      xs={12}
                      lg={12}
                      md={12}
                      sm={12}
                      es={12}
                      style={dialogUserData}
                    >
                      <Label className="dialogUpdateUserAddress-label">
                        {t("dialogUpdateUserAddress.email")}
                      </Label>
                      <Field
                        tabindex="1"
                        type="text"
                        name="email"
                        component={Input}
                        required={true}
                        id={"email"}
                        value={props.email || ""}
                        disabled={true}
                        onChange={props.handleChangeGeneral}
                        className="dialogUpdateUserAddress-input"
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      lg={12}
                      md={12}
                      sm={12}
                      es={12}
                      style={dialogUserData}
                    >
                      <Label className="dialogUpdateUserAddress-label">
                        {t("dialogUpdateUserAddress.firstName")}
                      </Label>
                      <Field
                        tabindex="3"
                        type="text"
                        name="firstName"
                        component={InputsFormPure}
                        required={true}
                        id={"firstName"}
                        value={props.firstName || ""}
                        onChange={props.handleChangeGeneral}
                        className="dialogUpdateUserAddress-input"
                      />
                    </Grid>
                    {props.errorFirstName === true ? (
                      <div style={{ marginLeft: "5px" }}>
                        <span className="hint-message-error">
                          {t("dialogUpdateUserAddress.errorFirstName")}
                        </span>
                      </div>
                    ) : null}
                    <Grid
                      item
                      xs={12}
                      lg={12}
                      md={12}
                      sm={12}
                      es={12}
                      style={dialogUserData}
                    >
                      <Label className="dialogUpdateUserAddress-label">
                        {t("dialogUpdateUserAddress.firstLastName")}
                      </Label>
                      <Field
                        tabindex="4"
                        name="firstLastName"
                        type="text"
                        component={Input}
                        required={true}
                        id={"firstLastName"}
                        value={props.firstLastName || ""}
                        onChange={props.handleChangeGeneral}
                        className="dialogUpdateUserAddress-input"
                      />
                    </Grid>
                    {props.errorFirstLastName === true ? (
                      <div style={{ marginLeft: "5px" }}>
                        <span className="hint-message-error">
                          {t("dialogUpdateUserAddress.errorFirstLastName")}
                        </span>
                      </div>
                    ) : null}
                    <Grid
                      item
                      xs={12}
                      lg={12}
                      md={12}
                      sm={12}
                      es={12}
                      style={dialogUserData}
                    >
                      <Label className="dialogUpdateUserAddress-label">
                        {t("dialogUpdateUserAddress.secondLastName")}
                      </Label>
                      <Field
                        tabindex="5"
                        type="text"
                        name="secondLastName"
                        component={Input}
                        required={true}
                        id={"secondLastName"}
                        value={props.secondLastName || ""}
                        onChange={props.handleChangeGeneral}
                        className="dialogUpdateUserAddress-input"
                      />
                    </Grid>
                    {props.errorSecondLastName === true ? (
                      <div style={{ marginLeft: "5px" }}>
                        <span className="hint-message-error">
                          {t("dialogUpdateUserAddress.errorSecondLastName")}
                        </span>
                      </div>
                    ) : null}
                    <Grid
                      item
                      xs={12}
                      lg={12}
                      md={12}
                      sm={12}
                      es={12}
                      style={dialogUserData}
                    >
                      <Label className="dialogUpdateUserAddress-label">
                        {t("dialogUpdateUserAddress.cellphoneNumber")}
                      </Label>
                      <PhoneInput
                        id={"cellphoneNumber"}
                        placeholder=""
                        value={props.cellphoneNumber}
                        onChange={props.handleChangeCellPhone}
                        defaultCountry="MX"
                        international
                        name={"cellphoneNumber"}
                        countryCallingCodeEditable={false}
                        style={{
                          width: '-webkit-fill-available',
                          backgroundColor: 'white'
                        }}
                      />
                      {/* <Field
                        tabindex="6"
                        type="text"
                        name="cellphoneNumber"
                        component={Input}
                        required={true}
                        id={"cellphoneNumber"}
                        value={cellphoneNumber || ""}
                        onChange={props.handleChangeGeneral}
                        className="dialogUpdateUserAddress-input"
                      /> */}
                    </Grid>
                    {props.errorPhoneNumber === true ? (
                      <div style={{ marginLeft: "5px" }}>
                        <span className="hint-message-error">
                          {t("dialogUpdateUserAddress.errorPhoneNumber")}
                        </span>
                      </div>
                    ) : null}
                    <Grid
                      item
                      xs={12}
                      lg={12}
                      md={12}
                      sm={12}
                      es={12}
                      style={dialogUserData}
                    >
                      <Label className="dialogUpdateUserAddress-label">
                        {t("dialogUpdateUserAddress.phoneNumber")}
                      </Label>
                      <PhoneInput
                        id={"phoneNumber"}
                        placeholder=""
                        value={props.phoneNumber}
                        onChange={props.handleChangePhone}
                        defaultCountry="MX"
                        international
                        name={"phoneNumber"}
                        countryCallingCodeEditable={false}
                        style={{
                          width: '-webkit-fill-available',
                          backgroundColor: 'white'
                        }}
                      />
                      {/* <Field
                        tabindex="7"
                        type="text"
                        name="phoneNumber"
                        component={Input}
                        required={true}
                        id={"phoneNumber"}
                        value={phoneNumber || " "}
                        onChange={props.handleChangeGeneral}
                        className="dialogUpdateUserAddress-input"
                      /> */}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      lg={12}
                      md={12}
                      sm={12}
                      es={12}
                      style={dialogUserData}
                    >
                      <Label className="dialogUpdateUserAddress-label">
                        {t("dialogUpdateUserAddress.curp")}
                      </Label>
                      <Field
                        tabindex="8"
                        type="text"
                        name="curp"
                        component={Input}
                        required={true}
                        id={"curp"}
                        value={props.curp || " "}
                        onChange={props.handleChangeGeneral}
                        className="dialogUpdateUserAddress-input"
                      />
                    </Grid>
                    {props.errorCURP === true ? (
                      <div style={{ marginLeft: "5px" }}>
                        <span className="hint-message-error">
                          {t("dialogUpdateUserAddress.errorCURP")}
                        </span>
                      </div>
                    ) : null}
                  </Grid>

                  <Grid
                    xs={12}
                    lg={6}
                    md={6}
                    sm={12}
                    es={6}
                    spacing={12}
                    style={{ marginTop: 0 }}
                  >
                    <Grid
                      item
                      xs={12}
                      lg={12}
                      md={12}
                      sm={12}
                      es={12}
                      style={dialogUserData}
                    >
                      <Label className="dialogUpdateUserAddress-label">
                        {t("RFC")}
                      </Label>
                      <Field
                        tabindex="2"
                        type="text"
                        name="rfc"
                        component={Input}
                        id={"rfc"}
                        value={props.rfc || ""}
                        onChange={props.handleChangeGeneral}
                        className="dialogUpdateUserAddress-input"
                      />
                    </Grid>
                    {props.errorRFC === true ? (
                      <div style={{ marginLeft: "5px" }}>
                        <span className="hint-message-error">
                          {t("dialogUpdateUserAddress.errorRFC")}
                        </span>
                      </div>
                    ) : null}

                    {props.userTypeId !==
                      Number(process.env.REACT_APP_USER_TYPE_INVITADO) ? (
                      <Fragment>
                        <Grid
                          item
                          xs={12}
                          lg={12}
                          md={12}
                          sm={12}
                          es={12}
                          style={dialogUserData}
                        >
                          <Label className="dialogUpdateUserAddress-label">
                            {t("dialogUpdateUserAddress.street")}
                          </Label>
                          <Field
                            tabindex="8"
                            type="text"
                            name="street"
                            component={Input}
                            required={true}
                            id={"street"}
                            value={props.street || ""}
                            onChange={props.handleChangeGeneral}
                            className="dialogUpdateUserAddress-input"
                          />
                        </Grid>
                        {props.errorStreet === true ? (
                          <div style={{ marginLeft: "5px" }}>
                            <span className="hint-message-error">
                              {t("dialogUpdateUserAddress.errorStreet")}
                            </span>
                          </div>
                        ) : null}
                        <Grid
                          item
                          xs={12}
                          lg={12}
                          md={12}
                          sm={12}
                          es={12}
                          style={dialogUserData}
                        >
                          <Label className="dialogUpdateUserAddress-label">
                            {t("dialogUpdateUserAddress.colony")}
                          </Label>
                          <Field
                            tabindex="9"
                            type="text"
                            name="colony"
                            component={Input}
                            required={true}
                            id={"colony"}
                            value={props.colony || ""}
                            onChange={props.handleChangeGeneral}
                            className="dialogUpdateUserAddress-input"
                          />
                        </Grid>
                        {props.errorColony === true ? (
                          <div style={{ marginLeft: "5px" }}>
                            <span className="hint-message-error">
                              {t("dialogUpdateUserAddress.errorColony")}
                            </span>
                          </div>
                        ) : null}
                        <Grid
                          item
                          xs={12}
                          lg={12}
                          md={12}
                          sm={12}
                          es={12}
                          style={dialogUserData}
                        >
                          <Label className="dialogUpdateUserAddress-label">
                            {t("dialogUpdateUserAddress.township")}
                          </Label>
                          <Field
                            tabindex="10"
                            type="text"
                            name="township"
                            component={Input}
                            required={true}
                            id={"township"}
                            value={props.township || ""}
                            onChange={props.handleChangeGeneral}
                            className="dialogUpdateUserAddress-input"
                          />
                        </Grid>
                        {props.errorTownship === true ? (
                          <div style={{ marginLeft: "5px" }}>
                            <span className="hint-message-error">
                              {t("dialogUpdateUserAddress.errorTownship")}
                            </span>
                          </div>
                        ) : null}
                        <Grid
                          item
                          xs={12}
                          lg={12}
                          md={12}
                          sm={12}
                          es={12}
                          style={dialogUserData}
                        >
                          <Label className="dialogUpdateUserAddress-label">
                            {t("dialogUpdateUserAddress.state")}
                          </Label>
                          <Field
                            tabindex="11"
                            type="text"
                            name="state"
                            component={Input}
                            required={true}
                            id={"state"}
                            value={props.state || ""}
                            onChange={props.handleChangeGeneral}
                            className="dialogUpdateUserAddress-input"
                          />
                        </Grid>
                        {props.errorState === true ? (
                          <div style={{ marginLeft: "5px" }}>
                            <span className="hint-message-error">
                              {t("dialogUpdateUserAddress.errorState")}
                            </span>
                          </div>
                        ) : null}
                        <Grid
                          item
                          xs={12}
                          lg={12}
                          md={12}
                          sm={12}
                          es={12}
                          style={dialogUserData}
                        >
                          <Label className="dialogUpdateUserAddress-label">
                            {t("dialogUpdateUserAddress.zipCode")}
                          </Label>
                          <Field
                            tabindex="12"
                            type="text"
                            name="zipCode"
                            component={Input}
                            required={true}
                            id={"zipCode"}
                            value={props.zipCode || ""}
                            onChange={props.handleChangeGeneral}
                            className="dialogUpdateUserAddress-input"
                          />
                        </Grid>
                        {props.errorZipCode === true ? (
                          <div style={{ marginLeft: "5px" }}>
                            <span className="hint-message-error">
                              {t("dialogUpdateUserAddress.errorZipCode")}
                            </span>
                          </div>
                        ) : null}
                      </Fragment>
                    ) : null}
                  </Grid>
                  <Grid xs={12} lg={12} md={12} sm={12} es={6} spacing={12}>
                    {/* Buttons group */}
                    <div
                      item
                      xs={12}
                      lg={12}
                      md={12}
                      sm={12}
                      es={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: " 35px 0 10px",
                      }}
                    >
                      <button
                        className="dialogUpdateUserAddress-user-cancel"
                        onClick={props.toggleDialogUpdateUserAddress}
                      >
                        {t("dialogUpdateUserAddress.buttonCancel")}
                      </button>
                      <button
                        className="button-update-user-accept"
                        onClick={(e) => {
                          props.onSubmitUpdateUserAddress(e);
                        }}
                        tabIndex="13"
                      >
                        {t("dialogUpdateUserAddress.buttonAccept")}
                      </button>
                    </div>
                  </Grid>
                </Grid>
              </FormElement>
            )}
          />
        </Dialog>
      )}

      {/* Alerts of Notification Completed and Loadign */}
      <DialogSystemGLPure
        {...props}
        toggleLoadingRequesting={props.toggleLoadingRequesting}
        toggleCompletedRequesting={props.toggleCompletedRequesting}
        toggleErrorRequesting={props.toggleErrorRequesting}
      />
    </div>
  );
};

export { DialogUpdateUserAddress as default };
